module.exports = __webpack_public_path__ + "img/www.foursquare.com.a02958f8.png";